function SensorSample(sample, timestampS) {
  this.set(sample, timestampS);
};

SensorSample.prototype.set = function(sample, timestampS) {
  this.sample = sample;
  this.timestampS = timestampS;
};

SensorSample.prototype.copy = function(sensorSample) {
  this.set(sensorSample.sample, sensorSample.timestampS);
};

module.exports = SensorSample;



//////////////////
// WEBPACK FOOTER
// ./~/webvr-polyfill/src/sensor-fusion/sensor-sample.js
// module id = 53
// module chunks = 0